<script>
import Search from './Search';
import i18n from '@/lib/i18n';
import { Collection, InvestorCollection } from '@/models';

export default {
    name: 'Investor',
    extends: Search,
    props: {
        label: {
            type: String,
            default: i18n.t('investor')
        },
        collection: {
            type: Collection,
            default: () => new InvestorCollection()
        },
        itemKey: {
            type: String,
            default: 'id'
        },
        itemText: {
            type: String,
            default: 'name'
        },
        itemTooltip: {
            type: String,
            default: 'gi_ref'
        }
    },
    data: () => ({
        createForm: () => import('@/components/forms/CreateInvestor')
    })
};
</script>
